import classnames from 'classnames';
import { Minus } from 'components/icons/Minus';
import { Plus } from 'components/icons/Plus';
import Styles from 'components/menu/Menu.module.scss';
import { GlamboxBadge } from 'core/glambox/GlamboxBadge';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { NavLink, withRouter } from 'react-router-dom';

// ----------------------------------------------------------------------

export const MENU_INTERNAL = 'MENU_INTERNAL';
export const MENU_EXTERNAL = 'MENU_EXTERNAL';

// ----------------------------------------------------------------------

const MenuItemContainer = ({
  label,
  path,
  type,
  icon,
  children,
  onClick,
  visible,
  active,
  badgeId,
  className,
  location,
}) => {
  if (active !== true) return null;
  let attr = {},
    navLink = null,
    plusOrMinus = null,
    IconComponent = icon,
    itemIcon = null,
    itemIconFill = GlamboxBadge.getJewelColor(badgeId),
    submenuClass = classnames(Styles.submenu, {
      [Styles.visible]: visible,
    });

  if (Array.isArray(children) && children.length > 0) {
    plusOrMinus = visible ? (
      <Minus fill={itemIconFill} />
    ) : (
      <Plus fill={itemIconFill} />
    );
  }

  if (IconComponent !== null) {
    itemIcon = <IconComponent fill={itemIconFill} />;
  }

  if (typeof onClick === 'function') attr.onClick = onClick;

  switch (type) {
    case MENU_EXTERNAL:
      attr.href = path;
      attr.target = '_blank';
      attr.className = classnames(
        {
          [Styles.active]: visible,
        },
        className
      );

      navLink = (
        <a {...attr}>
          {itemIcon}
          <span>{label}</span>
          {plusOrMinus}
        </a>
      );
      break;
    case MENU_INTERNAL:
    default:
      attr.to = path;
      attr.className = classnames(
        {
          [Styles.active]: path === location.pathname,
          [Styles.glamshop]: path.includes('glamstar'),
        },
        className
      );

      if (visible === true) {
        attr.activeClassName = Styles['active'];
      }

      navLink = (
        <NavLink {...attr}>
          {itemIcon}
          <span>{label}</span>
          {plusOrMinus}
        </NavLink>
      );
      break;
  }

  const menuClass = classnames(Styles['item']);

  return (
    <div className={menuClass}>
      {navLink}

      <MenuRenderer
        menu={children}
        badgeId={badgeId}
        className={submenuClass}
        isRoot={false}
      />
    </div>
  );
};

MenuItemContainer.defaultProps = {
  path: null,
  type: MENU_INTERNAL,
  icon: null,
  children: null,
  onClick: null,
  visible: false,
  toggle: null,
  active: true,
  badgeId: null,
  className: null,
  location: null,
};

MenuItemContainer.propTypes = {
  label: PropTypes.string.isRequired,
  path: PropTypes.string,
  type: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  icon: PropTypes.any,
  children: PropTypes.any,
  onClick: PropTypes.func,
  visible: PropTypes.bool,
  toggle: PropTypes.func,
  active: PropTypes.bool,
  badgeId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string),
  ]),
  location: PropTypes.object,
};

export const MenuItem = withRouter(MenuItemContainer);

// ----------------------------------------------------------------------

export class MenuRenderer extends Component {
  state = {
    visible: {},
  };

  toggle = key => {
    let _clone = Object.assign({}, this.state.visible);
    Object.keys(_clone).forEach(item => {
      if (key !== item) _clone[item] = false;
    });

    this.setState({
      visible: Object.assign({}, this.state.visible, _clone, {
        [key]: !this.state.visible[key],
      }),
    });
  };

  renderMenuList = () => {
    const { menu, isRoot, badgeId } = this.props;

    if (!menu) return null;
    return menu.map((item, key) => {
      const { onClick } = item;

      if (isRoot === true) {
        item.onClick = evt => {
          if (Array.isArray(item.children) && item.children.length > 0) {
            if (evt && evt.preventDefault) evt.preventDefault();
          }
          this.toggle(key);
          if (typeof onClick === 'function') onClick(evt);
        };
      }

      item.visible = this.state.visible[key] === true;
      return <MenuItem badgeId={badgeId} key={key} {...item} />;
    });
  };

  render() {
    const { id, className } = this.props;

    let attr = {};
    if (id) attr.id = id;
    if (className) attr.className = classnames(className);

    return <nav {...attr}>{this.renderMenuList()}</nav>;
  }
}

MenuRenderer.defaultProps = {
  id: null,
  className: null,
  menu: null,
  badgeId: null,
  isRoot: true,
};

MenuRenderer.propTypes = {
  id: PropTypes.string,
  className: PropTypes.oneOfType(
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string)
  ),
  menu: PropTypes.arrayOf(PropTypes.any),
  badgeId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  isRoot: PropTypes.bool,
};
